import { useLanguage } from "../context/LanguageContext";
import { MaskedLine, Reveal } from "../components/Reveal";
import { MarqueeStrip } from "../components/MarqueeStrip";

export default function About() {
  const { lang, t } = useLanguage();
  const hindi = lang === "hi";

  return (
    <div className="pt-28 sm:pt-36" data-testid="about-page">
      <section className="mx-auto max-w-7xl px-5 sm:px-8">
        <MaskedLine delay={0.1}>
          <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold">{t.about.kicker}</span>
        </MaskedLine>
        <h1 className={`mt-5 max-w-3xl leading-[1.02] text-maroon ${hindi ? "font-hindi text-5xl sm:text-7xl" : "font-display text-6xl sm:text-8xl"}`} data-testid="about-title">
          <MaskedLine delay={0.25}>{t.about.title}</MaskedLine>
        </h1>
        <Reveal delay={0.5}>
          <p className={`mt-8 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg ${hindi ? "font-hindi" : ""}`} data-testid="about-intro">
            {t.about.intro}
          </p>
        </Reveal>
      </section>

      <div className="mt-20">
        <MarqueeStrip />
      </div>

      <section className="mx-auto max-w-7xl space-y-28 px-5 py-24 sm:px-8 sm:py-32" data-testid="about-chapters">
        {t.about.chapters.map((c, i) => {
          const flip = i % 2 === 1;
          return (
            <div key={c.n} className="grid items-center gap-10 lg:grid-cols-12 lg:gap-16">
              <Reveal className={`lg:col-span-5 ${flip ? "lg:order-2 lg:col-start-8" : "lg:col-start-1"}`}>
                <div className="img-print group overflow-hidden rounded-2xl border border-gold/30">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    data-testid={`about-chapter-image-${c.n}`}
                  />
                </div>
              </Reveal>
              <div className={`lg:col-span-6 ${flip ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
                <Reveal delay={0.15}>
                  <span className="font-display text-7xl font-semibold text-maroon/15">{c.n}</span>
                  <h2 className={`mt-4 text-3xl text-maroon sm:text-4xl ${hindi ? "font-hindi" : "font-display"}`} data-testid={`about-chapter-title-${c.n}`}>
                    {c.title}
                  </h2>
                  <p className={`mt-5 max-w-lg text-base leading-relaxed text-ink/60 ${hindi ? "font-hindi" : ""}`}>
                    {c.text}
                  </p>
                  <span className="mt-8 block h-px w-16 bg-gold" />
                </Reveal>
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}
